var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormModel',{attrs:{"add-action":_vm.addAction,"delete-action":_vm.deleteAction,"view-action":false,"update-action":"","type":"EVALUATION_TRAINING_HOT"}})}
var staticRenderFns = []

export { render, staticRenderFns }